export const EXPERIENCE_TIMELINE = [
  {
    years: "2024",
    role: "Personal Trainer Certification",
    place: "Sports Academy School, Lebanon",
    description:
      "Completed formal personal trainer certification, qualifying as a certified coach with expertise in program design, client assessment, and training methodology.",
  },
  {
    years: "2025",
    role: "Sport Nutrition Specialist",
    place: "CIS College",
    description:
      "Specialized training in sports nutrition, enabling evidence-based nutritional guidance across diverse athletic populations and fitness goals.",
  },
  {
    years: "2025",
    role: "Post-Rehabilitation Specialist",
    place: "Performex Academy of Health & Fitness",
    description:
      "Advanced workshop in post-rehabilitation techniques from the American Council on Exercise, enabling safe progression for recovering clients.",
  },
  {
    years: "2026",
    role: "Strength and Conditioning",
    place: "NCSF Middle East (National Council on Strength & Fitness)",
    description:
      "Certified Strength Coach.",
  },
  {
    years: "2026",
    role: "EREPS Registered Professional",
    place: "EREPS (European Register of Exercise Professionals)",
    description:
      "Internationally registered Exercise Professional specializing in Exercise in Pregnancy and PostPartum (EQF Level 5). Meets European standards and is bound by code of ethical practice.",
  },
  {
    years: "Current",
    role: "Freelance Coach & Performance Specialist",
    place: "Independent Practice",
    description:
      "Training 500+ clients with expertise in body recomposition, strength & conditioning, post-rehabilitation, prenatal/postnatal training, and sports nutrition. Delivering personalized, evidence-based programming.",
  },
];

